import api from '../../..'

const requests = {
    create: async ({ name, primaryPractice }) => {
        var response = await api.post(`/maarima/GeneralPractitioner`, {
            name,
            primaryPracticeId: primaryPractice.id
        })

        return response.data
    },
    update: async ({ id, name, primaryPractice }) => {
        var response = await api.put(`/maarima/GeneralPractitioner/${id}`, {
            name,
            primaryPracticeId: primaryPractice.id
        })

        return response.data
    },

    fetch: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/GeneralPractitioner`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })
        return response.data

        //start Faker
        //return fakerResponse
        //end Faker
    },
    fetchById: async (id) => {
        var response = await api.get(`/maarima/GeneralPractitioner/${id}`)
        return response.data

        //start Faker
        //return fakerResponse.data.filter((v) => v.id == id)[0]
        //end Faker
    }
}

export default requests
